import { render } from "./mvt-cardagent.vue?vue&type=template&id=354d26f6"
import script from "./mvt-cardagent.js?vue&type=script&lang=js"
export * from "./mvt-cardagent.js?vue&type=script&lang=js"

import "./mvt-cardagent.vue?vue&type=style&index=0&id=354d26f6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__